import qs from 'query-string';
import { apiConfig } from '../api-config';
import { GetVoucherParams } from './get-all';

export const getAllVoucher = async (params: GetVoucherParams) => {
  const query = qs.stringify(params);

  return apiConfig
    .get(`api/Voucher/getAll-by-cdUser?${query}`)
    .then((response) => response.data)
    .catch((err) => ({ hasErrors: true, err: err.message }));
};
